<template>
  <EmLink href="mailto:support@emissary.ai">
    <slot>support@emissary.ai</slot>
  </EmLink>
</template>
